/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Tab_InfoInputs */

const vi_customer_tab_info = /** @type {(inputs: Customer_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin`)
};

/**

* @param {Customer_Tab_InfoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_tab_info = /** @type {((inputs?: Customer_Tab_InfoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Tab_InfoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_tab_info(inputs)
});